export const handleChangeDataPageCategories = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_CATEGORIES', name, value
});